import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectAiModelAssignments = createSelector(
  getSystem,
  ({ aiModelAssignments }) => aiModelAssignments,
);
